module.exports = __webpack_public_path__ + "img/5.bb405531.png";